import React from 'react';
import { Helmet } from 'react-helmet';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ProviderPayment } from 'pages/ProviderPayment';

import { ProviderSearch } from 'pages/ProviderSearch';
import { RedirectPage } from 'pages/RedirectPage';

function App() {
  return (
    <>
      <Helmet>
        <title>Provider Payment Portal</title>
      </Helmet>
      <Routes>
        <Route path="*" element={<Navigate to={'/home'} replace />} />
        <Route path="home" element={<ProviderSearch />} />
        <Route path="processor" element={<ProviderSearch />} />
        <Route path="search" element={<ProviderSearch />} />
        <Route path="payment" element={<ProviderPayment />} />
        <Route path="payment/complete" element={<RedirectPage to={'/search'} />} />
        <Route path="payment/cancel" element={<RedirectPage to={'/search'} />} />
      </Routes>
    </>
  );
}

export default App;
